import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidatorService } from './validator.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class DefaultValidatorService implements ValidatorService {
    public notify = new Subject<any>();
    public notifyObservable$ = this.notify.asObservable();

    public getFormGroup(): FormGroup {
        return new FormGroup({});

    }

    public notifyOther(data: any): boolean {
        if (data) {
            this.notify.next(data);
        }
        return true;
    }
}
